@if(isLoading()){
  <div class="loading-page">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <mat-spinner></mat-spinner>
}
